import React, { useEffect, useState } from 'react'
import {
  CssBaseline,
  ThemeProvider,
  StyledEngineProvider,
  responsiveFontSizes,
} from '@mui/material'
import Pusher from 'pusher-js'
import { Provider } from 'react-redux'
import AppRoutes from '~/routes'
import { store } from '~/store'
import { theme } from '~/theme'
import { ls } from '~/utils/localStorage'
import Toastification from '~/components/Toastification'

const App: React.FunctionComponent = () => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={responsiveFontSizes(theme)}>
      <CssBaseline />
      <AppRoutes />
      <Toastification />
    </ThemeProvider>
  </StyledEngineProvider>
)

const AppWrapper: React.FunctionComponent = () => {
  const [userNotificationCount, setUserNotificationCount] = useState(0)
  localStorage.setItem('userNotification', userNotificationCount.toString())
  const { id }: any = ls.get('user')
  useEffect(() => {
    const pusher = new Pusher('ff70622a77eaa9bfe5e9', {
      cluster: 'eu',
    })

    const channel = pusher.subscribe(`userNotifications.${id}`)
    channel.bind('App\\Events\\RealTimeUserNotifications', () => {
      setUserNotificationCount((prevCount) => prevCount + 1)
      localStorage.setItem('userNotification', userNotificationCount.toString())
    })
    return () => {
      channel.unbind('App\\Events\\RealTimeUserNotifications') // Unbind the event handler
      pusher.unsubscribe(`userNotifications.${id}`) // Unsubscribe from the user-specific channel
      pusher.disconnect() // Disconnect Pusher
    }
  }, [id])

  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

export default AppWrapper
